import React, { useState, useRef } from 'react';
import { Form, Button, InputGroup } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import './MessageComposer.css';

function MessageComposer({ onSend, onTyping, disabled = false, placeholder = 'Type a message...' }) {
  const [message, setMessage] = useState('');
  const [sending, setSending] = useState(false);
  const textareaRef = useRef(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!message.trim() || disabled || sending) return;

    const messageToSend = message.trim();
    setMessage('');
    setSending(true);

    try {
      await onSend(messageToSend);
    } catch (error) {
      // Restore message on error
      setMessage(messageToSend);
      console.error('Failed to send message:', error);
    } finally {
      setSending(false);
      textareaRef.current?.focus();
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  const handleChange = (e) => {
    const value = e.target.value;
    if (value.length <= 2000) {
      setMessage(value);
      
      // Trigger typing indicator
      if (onTyping && value.trim()) {
        onTyping();
      }
    }
  };

  const adjustTextareaHeight = () => {
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.height = 'auto';
      textarea.style.height = Math.min(textarea.scrollHeight, 120) + 'px';
    }
  };

  React.useEffect(() => {
    adjustTextareaHeight();
  }, [message]);

  const characterCount = message.length;
  const isNearLimit = characterCount > 1800;

  return (
    <div className="message-composer">
      <Form onSubmit={handleSubmit}>
        <InputGroup>
          <Form.Control
            ref={textareaRef}
            as="textarea"
            rows={1}
            value={message}
            onChange={handleChange}
            onKeyPress={handleKeyPress}
            placeholder={placeholder}
            disabled={disabled || sending}
            className="message-input"
          />
          <Button
            type="submit"
            variant="primary"
            disabled={!message.trim() || disabled || sending}
            className="send-button"
          >
            <FontAwesomeIcon icon={faPaperPlane} />
          </Button>
        </InputGroup>
        {isNearLimit && (
          <div className="character-count text-muted">
            {characterCount} / 2000 characters
          </div>
        )}
      </Form>
    </div>
  );
}

export default MessageComposer;
